import { Dialog } from "@material-ui/core";
import React from "react";
import CreateAlert from "../../global-alerts/CreateAlert";

/**
 * SendAlertModal component renders a modal dialog to send an alert email
 * to a specified dealer. It allows users to input a subject and message,
 * and handles the submission of the email as well as sending a personal
 * alert to the dealer.
 *
 * @param {object} props - The properties object.
 * @param {boolean} props.open - Indicates whether the modal is open.
 * @param {Function} props.onClose - Function to close the modal.
 * @param {object} props.dealer - Object containing dealer information.
 *
 * @returns {React.Element} The SendAlertModal component.
 */
export default function SendAlertModal({ open, onClose, dealer }) {
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={() => handleClose()}
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 16, // Rounded corners like a card
        },
      }}
    >
      <CreateAlert dealer={dealer} withSubmit={handleClose} />
    </Dialog>
  );
}
